import useTranslation from 'next-translate/useTranslation';
import Image from 'next/image';
import ArrowIcon from 'public/arrow.svg';
import { ReactNode, useState } from 'react';
import { UnmountClosed } from 'react-collapse';
import { Arrow, Icon, ListHeader } from './SidebarList.styled';

type Props = {
  icon: string;
  listItem: any;
  children: ReactNode;
  isActive?: any;
  defaultOpen?: boolean;
};

export default function SidebarList({ children, icon, listItem, defaultOpen }: Props) {
  const { t } = useTranslation('Profile');
  const [isOpen, setIsOpen] = useState(Boolean(defaultOpen));
  return (
    <div>
      <ListHeader open={isOpen} onClick={() => setIsOpen(!isOpen)}>
        <Icon>
          <Image src={icon} width={17.94} height={18} alt="user" />
        </Icon>
        {listItem}
        {/* {t('personal_account')} */}
        <Arrow>
          <Image src={ArrowIcon} width={7.05} height={12} alt="arrow" />
        </Arrow>
      </ListHeader>
      <UnmountClosed isOpened={isOpen}>{children}</UnmountClosed>
    </div>
  );
}
